// extracted by mini-css-extract-plugin
export default {"container":"style_container__ftmFR","logo":"style_logo__W-2Fd","subtitle":"style_subtitle__ZgzP7"};